import React, { useEffect, useContext, useState } from 'react';
import Highlight from 'react-highlight';
import { Card, CardBody, CardHeader, CardHeaderBtn } from './../../components/card/card.jsx';
import { AppSettings } from './../../config/app-settings.js';

function LayoutBoxedLayout() {
	const context = useContext(AppSettings);
	const [code1, setCode1] = useState();
	
	useEffect(() => {
		fetch('/quantum-react/assets/data/layout/boxed-layout-code-1.json').then(function(response) { return response.text(); }).then((html) => { setCode1(html); });
		context.setAppBoxedLayout(true);
		
		return function cleanUp() {
			context.setAppBoxedLayout(false);
		}
		
		// eslint-disable-next-line
	}, []);
	
	return (
		<div>
			<ul className="breadcrumb">
				<li className="breadcrumb-item"><a href="#/">LAYOUT</a></li>
				<li className="breadcrumb-item active">BOXED LAYOUT</li>
			</ul>
			
			<h1 className="page-header">
				Boxed Layout <small>page header description goes here...</small>
			</h1>
			
			<Card>
				<CardHeader className="with-btn">
					INSTALLATION
					<CardHeaderBtn />
				</CardHeader>
				<CardBody>
					<p>
						Add the following code for boxed layout page setting.
					</p>
				</CardBody>
				<div className="hljs-container">
					<Highlight className='javascript'>{code1}</Highlight>
				</div>
			</Card>
		</div>
	)
}

export default LayoutBoxedLayout;